<template>
    <div class="question-wrap">
        <div class="actual-question-icon" id="questionPop">
            <span class="actual-question-icon" @mouseover="showPopupClass = 'showme'" @mouseleave="showPopupClass = '' ">
              <question class="svg-24 svg-black"></question>
            </span>
            <div class="question-content" id="questionPopContent" :class="showPopupClass" @mouseover="showPopupClass = 'showme'" @mouseleave="showPopupClass = ''">
                <div class="question-content-wrap">
                    <div class="contact--email"><i class="yellow fa fa-at"></i>
                        <div class=""><label>Email</label><span><a
                            :href="'mailto:' + emailaddress" v-text="emailaddress"></a></span>
                        </div>
                    </div>
                    <div class="contact--download">
                        <a href="https://www.emmys.com/foundation/programs/cta" target="_blank">
                            <i class="yellow fa fa-link"></i>
                            <div class="">
                                <label>Link</label>
                                <span>CTA Rules</span>
                            </div>
                        </a>
                    </div>
                </div>
        </div>
    </div>
</div>
</template>

<script>



    import Question from "./icons/question";
    export default {
      components: {Question},
      props: ['emailaddress', 'phone'],
        data() {
            return {
                showPopupClass: '',
            }
        },
    }
</script>
